<div class="section-footer">
  <div class="show-count">
    <span class="label">Show:</span>
    <select class="show-select" [value]="pageSize" (change)="pageSizeChange.emit($any($event.target).value)">
      @for (option of pageSizeOptions; track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </div>
  <div class="paging-controls">
    <div class="paging">Page {{ currentPage }} of {{ totalPages }}</div>
    <div class="pager-buttons">
      <button type="button" class="pager-btn" [disabled]="!canGoPrev" (click)="prevPage.emit()" aria-label="Previous page">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M15 18L9 12L15 6"/>
        </svg>
      </button>
      <button type="button" class="pager-btn" [disabled]="!canGoNext" (click)="nextPage.emit()" aria-label="Next page">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 18L15 12L9 6"/>
        </svg>
      </button>
    </div>
  </div>
</div>
